var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashOutlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5938 2.9375C11.9492 2.9375 12.25 3.23828 12.25 3.59375C12.25 3.97656 11.9492 4.25 11.5938 4.25H11.2656L10.6094 13.1367C10.5273 14.0664 9.78906 14.75 8.85938 14.75H3.36328C2.43359 14.75 1.69531 14.0664 1.61328 13.1367L0.957031 4.25H0.65625C0.273438 4.25 0 3.97656 0 3.59375C0 3.23828 0.273438 2.9375 0.65625 2.9375H2.54297L3.55469 1.43359C3.82812 1.02344 4.32031 0.75 4.83984 0.75H7.38281C7.90234 0.75 8.39453 1.02344 8.66797 1.43359L9.67969 2.9375H11.5938ZM4.83984 2.0625C4.75781 2.0625 4.67578 2.11719 4.64844 2.17188L4.12891 2.9375H8.09375L7.57422 2.17188C7.54688 2.11719 7.46484 2.0625 7.38281 2.0625H4.83984ZM9.95312 4.25H2.26953L2.92578 13.0547C2.95312 13.2734 3.14453 13.4375 3.36328 13.4375H8.85938C9.07812 13.4375 9.26953 13.2734 9.29688 13.0547L9.95312 4.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashOutlineIcon);
export default __webpack_public_path__ + "static/media/trash-outline-icon.95a829d53bfc4775805e21461a0a37cf.svg";
export { ForwardRef as ReactComponent };